module.exports = __webpack_public_path__ + "img/16_37.27de4b17.png";